import React, { ReactNode } from 'react'
import { RootState } from '../../redux/root'
import { useRootSelector } from '../../utils/hooks'

interface Props<T> {
    selector: (state: RootState) => T,
    render: (value: T) => ReactNode,
}

function Selector <T>(props: Props<T>): JSX.Element {
    const value = useRootSelector(props.selector)
    return <>{props.render(value)}</>
}

export default Selector